import React from "react";
import { useFlagsRemoteData } from "src/components/Providers/FeatureFlagProvider";
import useCheckUserRole from "src/hooks/useCheckUserRole";
import { useMfaApi } from "src/hooks/useMfaApi";
import * as RD from "src/types/remoteData";

export type MyProfileHomePage =
  | "redirect-to-mfa"
  | "redirect-to-notification"
  | "not-found";

export const useMyProfileHomePage = () => {
  const featureFlagRD = useFlagsRemoteData(["staff-notifications"]);
  const { isMfaEnabledRemoteData } = useMfaApi();
  const { isAvelaAdmin } = useCheckUserRole();

  return React.useMemo((): RD.RemoteData<unknown, MyProfileHomePage> => {
    return RD.map2(
      featureFlagRD,
      isMfaEnabledRemoteData,
      (featureFlags, isMfaEnabled): MyProfileHomePage => {
        if (isMfaEnabled && !isAvelaAdmin) {
          // we don't allow avela admin to manage their MFA yet until we figure out the right workflow for this - abadi
          return "redirect-to-mfa";
        } else if (featureFlags["staff-notifications"].enabled) {
          return "redirect-to-notification";
        }

        return "not-found";
      }
    );
  }, [featureFlagRD, isMfaEnabledRemoteData, isAvelaAdmin]);
};
